import { CAT_STANDING_REPORTS } from 'App/utils/Collections';

export default {
  category: CAT_STANDING_REPORTS,
  filters: [],
};
